import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';
import { SolicitudDTO } from 'src/app/core/models/vinculacion/vinculacion-Interfaces';
import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlVinculacion;

@Injectable()
export class SolicitudService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) { }

  getSolicitudPorNumeroIdentificacionService(numeroIdentificacion: string): Observable<BodyListResponse<SolicitudDTO>> {
    return this.http.get<BodyListResponse<SolicitudDTO>>(API_URL + '/api/v1/solicitud/estudiante/' + numeroIdentificacion);
  }

  getSolicitudPorNumeroIdentificacionFlujoTrabajoService(numeroIdentificacion: string, codigoFlujo: string): Observable<BodyListResponse<SolicitudDTO>> {
    return this.http.get<BodyListResponse<SolicitudDTO>>(API_URL + '/api/v1/solicitud/estudiante/' + numeroIdentificacion + '/flujo/' + codigoFlujo);
  }

  getSolicitudPorCarreraService(carrera: string): Observable<BodyListResponse<SolicitudDTO>> {
    return this.http.get<BodyListResponse<SolicitudDTO>>(API_URL + '/api/v1/solicitud/carrera/' + carrera);
  }

  getSolicitudService(): Observable<BodyListResponse<SolicitudDTO>> {
    return this.http.get<BodyListResponse<SolicitudDTO>>(API_URL + '/api/v1/solicitud/todos');
  }


  guardarSolicitudService(solicitudDTO: SolicitudDTO): Observable<BodyResponse<SolicitudDTO>> {
    return this.http.post<any>(API_URL + '/api/v1/solicitud', solicitudDTO);
  }

  getSolicitudPorCodigoSolicitudService(codigoSolicitud: string): Observable<BodyResponse<SolicitudDTO>> {
    return this.http.get<BodyResponse<SolicitudDTO>>(API_URL + '/api/v1/solicitud/' + codigoSolicitud);
  }

  getSolicitudPorCodigoTutorService(codigoTutor: string): Observable<BodyListResponse<SolicitudDTO>> {
    return this.http.get<BodyListResponse<SolicitudDTO>>(API_URL + '/api/v1/solicitud/tutor/' + codigoTutor);
  }

  getCrearProyectoDesdeSolicitud(codigo: string): Observable<BodyResponse<Boolean>> {
    return this.http.get<BodyListResponse<SolicitudDTO>>(API_URL + '/api/v1/solicitud/crearProyecto/' + codigo);
  }
}
